/* tslint:disable */

/**
 */
export class Study {
    ID_REPORT?: number;
    CALCULATION_MODE?: number;
    CHAINING_ADD_COMP_ENABLE?: boolean;
    CHAINING_CONTROLS?: boolean;
    CHAINING_NODE_DECIM_ENABLE?: boolean;
    COMMENT_TXT?: string;
    CUSTOMER?: string;
    HAS_CHILD?: number;
    ID_HAVERAGE_RESULTS?: number;
    ID_PACKING?: number;
    ID_PRECALC_LDG_RATE_PRM?: number;
    ID_PRICE?: number;
    ID_PROD?: number;
    ID_PRODUCTION?: number;
    CALCULATION_STATUS?: number;
    ID_STUDY?: number;
    ID_STUDY_RESULTS?: number;
    ID_TEMP_RECORD_PTS?: number;
    ID_USER?: number;
    OPEN_BY_OWNER?: number;
    OPTION_CRYOPIPELINE?: boolean;
    OPTION_ECO?: boolean;
    OPTION_EXHAUSTPIPELINE?: boolean;
    PARENT_ID?: number;
    PARENT_STUD_EQP_ID?: number;
    STUDY_NAME?: string;
    TO_RECALCULATE?: number;
    USERNAM?: string;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/study.ts